module.exports = "<div class=\"section-pin\">\n  <p ng-if=\"note\" ng-bind-html=\"note\"></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/directives/note/note.html
// module id = 78
// module chunks = 0